/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/8/22
 */

import {gql} from "urql";
import {VegaEvent} from "../../interfaces/Global";

export const CreateCalendarEventMutation = gql`
    mutation CreateCalendarEvent($data: CalendarEventInput!) {
        createCalendarEvent(data: $data) {
            id
            createdBy
            createdByEmployee {
                id
                displayName
            }
            creationDate
            modifiedBy
            modifiedByEmployee {
                id
                displayName
            }
            modifiedDate
            vstamp
            employeeId
            employee {
                id
                displayName
            }
	        typeId
            startDatetime
            endDatetime
            isConfirmed
            confirmationDate
            confirmedBy
            confirmedByEmployee {
                id
                displayName
            }
            description
	        capacityModifier
	        properties
        }
    }
`;

export const UpdateCalendarEventMutation = gql`
    mutation UpdateCalendarEvent($id: Int!,$data: CalendarEventInput!) {
        updateCalendarEvent(id: $id, data: $data) {
            id
            createdBy
            createdByEmployee {
                id
                displayName
            }
            creationDate
            modifiedBy
            modifiedByEmployee {
                id
                displayName
            }
            modifiedDate
            vstamp
            employeeId
            employee {
                id
                displayName
            }
	        typeId
            type {
                id
                name
                isUnavailable
                parent {
                    id
                    name
                }
            }
            startDatetime
            endDatetime
            isConfirmed
            confirmationDate
            confirmedBy
            confirmedByEmployee {
                id
                displayName
            }
            description
	        capacityModifier
	        properties
        }
    }
`;

export interface CalendarEventInput {
	employeeId?: string
	typeId?: string
	startDatetime?: Date
	endDatetime?: Date
	isConfirmed?: boolean
	description?: string
	capacityModifier?: number
}

export interface CalendarEventVars {
	data: CalendarEventInput
}

export interface CreateCalendarEventResponse {
	createCalendarEvent: VegaEvent
}

export const DeleteCalendarEventMutation = gql`
	mutation DeleteCalendarEvent($id: Int!) {
		deleteCalendarEvent(id: $id) 
	}
`;

export interface DeleteCalendarEventResponse {
	deleteCalendarEvent: boolean
}

export interface DeleteCalendarEventVars {
	id: number
}

export interface UpdateCalendarEventResponse {
	updateCalendarEvent: boolean
}

export interface UpdateCalendarEventVars {
	id: number
	data: CalendarEventInput
}